import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormComponentProps } from 'types/components';
import {
  DatePicker,
  DatePickerProps,
} from 'up-ops-web-shared-components/lib/components/date-picker';
import { AccessibleLabelProps } from 'up-ops-web-shared-components/lib/lib/types';

type FormDatePickerProps = FormComponentProps &
  Omit<DatePickerProps, 'onDateSelect'> &
  AccessibleLabelProps;

const FormDatePicker = ({
  defaultValue,
  name,
  rules,
  ...props
}: FormDatePickerProps) => {
  const { control, formState } = useFormContext();
  const { i18n } = useTranslation();
  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      render={({ field, fieldState }) => {
        const { onBlur, onChange, value } = field;
        const { error, invalid } = fieldState;
        return (
          <DatePicker
            disabled={formState.isSubmitting}
            error={invalid}
            hint={error?.message}
            name={name}
            locale={i18n.language}
            onBlur={onBlur}
            onDateSelect={onChange}
            selected={value}
            {...props}
          />
        );
      }}
      rules={rules}
    />
  );
};

export default FormDatePicker;
